// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"409":"c7d7b290","981":"6b804b57"}[chunkId] + ".chunk.css";
};